// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__nhZxe","select":"Header_select__U4Krf","clinic":"Header_clinic__1OM-u"};